/**
 * Monta href mailto: abrindo o cliente de e-mail padrão (Outlook, etc.)
 * com assunto/corpo opcionais pré-preenchidos.
 *
 * @param {string} email
 * @param {{ subject?: string, bodyLines?: Array<string|null|undefined> }} [options]
 * @returns {string|undefined}
 */
export function buildContactMailtoHref(email, options = {}) {
  const trimmed = String(email || "").trim();
  if (!trimmed) return undefined;

  const subject = String(options.subject || "").trim();
  const bodyLines = Array.isArray(options.bodyLines)
    ? options.bodyLines.filter((line) => line != null && String(line).length > 0)
    : [];

  const params = [];
  if (subject) {
    params.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (bodyLines.length > 0) {
    params.push(`body=${encodeURIComponent(bodyLines.join("\n"))}`);
  }

  return params.length > 0
    ? `mailto:${trimmed}?${params.join("&")}`
    : `mailto:${trimmed}`;
}

/**
 * Contexto de alerta Guardian para mailto nos cards de responsáveis.
 */
export function buildAlertContactMailtoHref(email, alert = {}, codAlertaFallback = "") {
  const code = alert?.cod_alerta || codAlertaFallback || "";
  const area = alert?.area_title || "";
  const subject = code
    ? `Alerta ${code}${area ? ` — ${area}` : ""}`
    : area
      ? `Alerta Guardian — ${area}`
      : "Alerta Guardian";

  return buildContactMailtoHref(email, {
    subject,
    bodyLines: [
      code ? `Código do alerta: ${code}` : null,
      area ? `Área: ${area}` : null,
      alert?.alert_type_description
        ? `Tipo: ${alert.alert_type_description}`
        : null,
      alert?.severity_level_description
        ? `Severidade: ${alert.severity_level_description}`
        : null,
      "",
      "Olá,",
      "",
    ],
  });
}

/**
 * Contexto de projeto interno para mailto nos participantes/responsáveis.
 */
export function buildProjectContactMailtoHref(
  email,
  { projectTitle = "", areaName = "", personName = "" } = {}
) {
  const subject = projectTitle
    ? `Projeto ${projectTitle}${areaName ? ` — ${areaName}` : ""}`
    : areaName
      ? `Área ${areaName}`
      : "Contato Vert Ecotech";

  return buildContactMailtoHref(email, {
    subject,
    bodyLines: [
      projectTitle ? `Projeto: ${projectTitle}` : null,
      areaName ? `Área: ${areaName}` : null,
      personName ? `Destinatário: ${personName}` : null,
      "",
      "Olá,",
      "",
    ],
  });
}
